import { useContext, useEffect } from "react";
import { PageNameContext } from "src/App";

export const usePageName = (name: string) => {
  const { setPageName } = useContext(PageNameContext);
  useEffect(() => {
    setPageName(name);
  }, [name, setPageName]);
};
